export default __webpack_public_path__ + "static/media/amerihealth-logo.e29f3d13.png";